import * as React from "react";
const SvgFiBrandsCentos = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-centos_svg__a)">
      <path
        fill="#151A2D"
        d="M3.348 8.713 0 12.01l3.35 3.298v5.39h5.373l3.285 3.235 3.285-3.235h5.43v-5.375L24 12.025l-3.232-3.252V3.32h-5.457L12.076.065 8.883 3.277H3.348zM12.076.815l2.491 2.506h-1.69v6.441l-.8.805-.81-.815V3.279H9.627zm-8.2 2.99h4.483L6.485 5.693l4.253 4.279v.654h-.796L5.675 6.422l-1.798 1.77V3.807zm5.227 0h1.635v5.416L7.23 5.69zm4.302.044h1.687l1.83 1.842-3.517 3.539zm2.431 0h4.404v4.394L18.41 6.4l-4.242 4.267h-.764v-.69l4.261-4.288zm2.573 3.3 1.831 1.843v1.677h-5.328zm-12.734.014 3.515 3.462H3.876v-1.69zM3.35 14.567.753 12.01l2.595-2.556v1.698h6.377l.871.858-.782.77H3.35zm17.42-5.045 2.487 2.504-2.534 2.549v-1.796h-6.41l-.749-.754.825-.83h6.38zm-9.504.979.81.815.187-.188.614-.618v.686h.768l-.825.83.75.754h-.719v.808l-.842-.83-.74.73v-.706h-.702l.782-.77-.188-.185-.683-.673h.788zm-7.389 2.807h5.402l-3.604 3.549-1.798-1.771zm6.154 0h.708v.7l-4.404 4.337 1.852 1.824h-4.31v-4.342l1.798 1.77zm3.348.799v-.8h.716l4.316 4.344.186-.187 1.6-1.61v4.317h-4.367l1.853-1.825zm1.46-.8h5.357v1.799l-1.785 1.796zm-2.83.192.842.829v6.37h1.691l-2.533 2.495-2.533-2.494h1.791v-6.47zm-1.27 1.25v5.42H8.94l-1.852-1.823zm2.64.098 3.552 3.498-1.853 1.825h-1.699z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-centos_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCentos;
